'use client';
import { createContext } from 'react';
import { ContextProps } from './interfaces';

export const SelectContext = createContext<ContextProps>({
    registerOption: undefined,
    selectActions: undefined,
});
